export default __webpack_public_path__ + "static/media/kili-pack2.e056e02a.jpg";